import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "./ThemeProvider";

/**
 * ThemeToggle — botão pill segmentado (☀ / ☾) que troca entre light e dark.
 * Respeita a paleta MUFT (#220F86 base) e usa framer-motion pra transição.
 */
export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? "Ativar modo claro" : "Ativar modo escuro"}
      onClick={toggleTheme}
      data-testid="theme-toggle"
      className={`relative inline-flex h-10 w-[74px] items-center rounded-full border transition-colors duration-500 ${
        isDark
          ? "border-white/15 bg-white/[0.06]"
          : "border-white/25 bg-white/[0.1]"
      } ${className}`}
    >
      {/* Sun icon */}
      <span
        className={`absolute left-[10px] flex h-5 w-5 items-center justify-center transition-colors ${
          isDark ? "text-white/40" : "text-white"
        }`}
      >
        <Sun className="h-4 w-4" strokeWidth={2.5} />
      </span>
      {/* Moon icon */}
      <span
        className={`absolute right-[10px] flex h-5 w-5 items-center justify-center transition-colors ${
          isDark ? "text-white" : "text-white/40"
        }`}
      >
        <Moon className="h-4 w-4" strokeWidth={2.5} />
      </span>
      {/* Sliding knob */}
      <motion.span
        layout
        aria-hidden
        className="absolute top-1 flex h-8 w-8 items-center justify-center rounded-full bg-white shadow-md"
        animate={{ x: isDark ? 34 : 2 }}
        transition={{ type: "spring", stiffness: 500, damping: 32 }}
      >
        <AnimatePresence mode="wait" initial={false}>
          <motion.span
            key={isDark ? "moon" : "sun"}
            initial={{ opacity: 0, rotate: -60, scale: 0.6 }}
            animate={{ opacity: 1, rotate: 0, scale: 1 }}
            exit={{ opacity: 0, rotate: 60, scale: 0.6 }}
            transition={{ duration: 0.25 }}
            className="text-navy-700"
          >
            {isDark ? (
              <Moon className="h-4 w-4" strokeWidth={2.5} />
            ) : (
              <Sun className="h-4 w-4" strokeWidth={2.5} />
            )}
          </motion.span>
        </AnimatePresence>
      </motion.span>
    </button>
  );
};

export default ThemeToggle;
